import { useEffect, useState } from "react";
import { CHART_TABS } from "../common/utils/constants";
import {
  QueryParams,
  chartTypes,
  metadataToInternalChartType,
} from "../common/utils/enum";
import ChartSection from "./ChartSection";
import Filters from "./Filters";
import { useDispatch, useSelector } from "react-redux";

import useQueryParams from "../common/hooks/useQueryParams";
import VisualizationNarrative from "./VisualizationNarrative";
import {
  getBoundariesAction,
  getCentroidsAction,
} from "./charts/common/mapUtils";

const Visualization = () => {
  const { indicatorMetadata, boundaryType } = useSelector(
    (state) => state.indicatorProfile,
  );
  const { endpointList, featureProps } = useSelector((state) => state.common);
  const { site } = featureProps;

  const dispatch = useDispatch();
  const { setQueryParam, getQueryParam, deleteQueryParams } = useQueryParams();

  const [chartType, setChartType] = useState(
    getQueryParam(QueryParams.View)
      ? getQueryParam(QueryParams.View)
      : chartTypes.Map,
  );
  const removeChartTypes =
    indicatorMetadata?.admin_metadata?.[site]?.visualization?.remove_chart?.map(
      (type) =>
        metadataToInternalChartType[type?.chart_types]
          ? metadataToInternalChartType[type?.chart_types]
          : type?.chart_types,
    ) || [];

  const filteredChartTabs =
    removeChartTypes?.length > 0
      ? CHART_TABS?.filter((tab) => !removeChartTypes?.includes(tab.id))
      : CHART_TABS;

  useEffect(() => {
    if (indicatorMetadata && removeChartTypes?.length > 0) {
      if (!filteredChartTabs?.some((tab) => tab.id === chartType)) {
        const newChartType = filteredChartTabs?.[0]?.id || chartTypes.Map;

        setChartType(newChartType);
        setQueryParam(QueryParams.View, newChartType);
      }
    }
  }, [indicatorMetadata]);

  useEffect(() => {
    if (chartType === chartTypes.Map && boundaryType !== null) {
      const boundaries = getBoundariesAction(boundaryType, endpointList);
      if (boundaries) {
        dispatch(boundaries);
      }

      const centroids = getCentroidsAction(endpointList);
      if (centroids) {
        dispatch(centroids);
      }
    }
  }, [chartType, boundaryType]);

  const isGenAI =
    getQueryParam(QueryParams.GenAI) &&
    getQueryParam(QueryParams.GenAI) === "true"
      ? true
      : false;

  return (
    <>
      <div
        className="embed-container responsivegrid aem-GridColumn aem-GridColumn--default--12"
      >
        <div className="container responsivegrid touchui-container aem-GridColumn aem-GridColumn--default--12">
          <div className="aem-Grid">
            {/* Embed changes: Removed the open/collapse filter button as it is not part of the embed functionality for now */}
            <section className="tui__comparison_container">
              <div className="aem-GridColumn aem-GridColumn--default--8 aem-GridColumn--desktop--8 aem-GridColumn--tablet--12 aem-GridColumn--phone--12 aem-GridColumn--xl-8 aem-GridColumn--xs-12 ">
                <ChartSection chartType={chartType} />
                {isGenAI && (
                  <div className="dataviz-narrative-section">
                    <VisualizationNarrative chartType={chartType} />
                  </div>
                )}
              </div>

              <div
                className="aem-GridColumn aem-GridColumn--default--4 aem-GridColumn--desktop--4 aem-GridColumn--tablet--12 aem-GridColumn--phone--12 aem-GridColumn--xl-4 aem-GridColumn--xs-12 tui_filter_collapse_Content collapse"
                id="id_filter_section_collapse"
                style={{ display: "none" }}
              >
                <div className="tabs panelcontainer lp__tab_full_row">
                  <div
                    className="cmp-tabs"
                    data-cmp-is="tabs"
                    data-placeholder-text="false"
                  >
                    {/* Embed changes: Removed scroller buttons as chart tabs are not displayed in embed mode */}

                    {/* Embed changes: Removed chart tabs (Map, Trend, Bar, etc.) as embed displays single chart type based on query params */}

                    <div
                      role="tabpanel"
                      tabIndex="0"
                      className="cmp-tabs__tabpanel cmp-tabs__tabpanel--active"
                      data-cmp-hook-tabs="tabpanel"
                      aria-labelledby={chartType}
                      aria-hidden="false"
                    >
                      <Filters chartType={chartType} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};
export default Visualization;
